/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {HelpIcon} from "../../HelpIcon";
import {RemoveItemButton} from "./RemoveItemButton";
import React from "react";

export const TagRemoveItemButton = (props) => {
    const { item = {} } = props;
    const { isAssigned } = item;
    
    if (isAssigned) {
        return <div className="remove-table pop-remove">
            <HelpIcon id={`help-icon-${item?.fileUploadTagId}`}>
                This tag has been auto-assigned and cannot be removed.
            </HelpIcon>
        </div>
    }
    
    return <RemoveItemButton {...props}/>;
}
